import * as React from "react";
import { TableCell } from "@mui/material";

interface PriceCellProps {
  value?: number | null;
}

/** Renders a backend-reported price verbatim — right-aligned, no formula applied (e.g. no market-value multiplication). */
export function PriceCell({ value }: PriceCellProps): React.JSX.Element {
  const isMissing = value === null || value === undefined;
  return (
    <TableCell align="right" sx={{ fontVariantNumeric: "tabular-nums" }}>
      {isMissing ? (
        <span style={{ fontStyle: "italic", opacity: 0.6 }}>Not reported by backend</span>
      ) : (
        value.toFixed(2)
      )}
    </TableCell>
  );
}
